import React, { PureComponent } from 'react';
import { toast } from 'react-toastify';
import GoogleLogin from 'react-google-login';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import Input from 'component/input.component';
import Button from 'component/button.component';
import googleLogo from 'resource/img/google.png';
import fbLogo from 'resource/img/facebook.png';
import { USER_LOGIN_ERROR, USER_LOGIN_SUCCESS } from 'config/constants';
import ResetPasswordModal from './reset.password.modal.component';

class LoginModal extends PureComponent {
  state = {
    login: '',
    password: '',
  };

  _onChangeLogin = event => this.setState({ login: event.currentTarget.value });

  _onChangePassword = event =>
    this.setState({ password: event.currentTarget.value });

  _userLogin = user => {
    const { userLogin, modalRef } = this.props;
    userLogin(user)
      .then(({ type, message }) => {
        if (type === USER_LOGIN_SUCCESS) {
          toast.success('Login realizado com sucesso!');
          modalRef._hide();
        } else if (type === USER_LOGIN_ERROR) {
          toast.error(message);
        }
      })
      .catch(err => {
        console.error('Por favor, entre em contato com o suporte.');
        toast.error('Usuário e/ou senha incorretos!');
      });
  };

  submitForm = e => {
    e.preventDefault();
    this._userLogin({
      type: 'DEFAULT',
      login: this.state.login,
      password: this.state.password,
    });
  };

  responseFacebook = res => {
    const { email, id, picture, name } = res;
    const image = picture.data ? picture.data.url : null;
    this._userLogin({
      type: 'FACEBOOK',
      login: email,
      provider_token: id,
      image,
      name,
    });
  };

  responseGoogle = response => {
    const {
      profileObj: { email, googleId, imageUrl, name },
    } = response;
    this._userLogin({
      type: 'GOOGLE',
      login: email,
      provider_token: googleId,
      image: imageUrl,
      name,
    });
  };

  responseProviderError = response => {
    toast.error('Não foi possível realizar o login. Tente novamente!');
    console.error(response);
  };

  _keyDown = e => {
    if (e.key === 'Enter') {
      this.submitForm(e);
    }
  };

  render() {
    const { login, password } = this.state;
    const { resetPassword } = this.props;

    return (
      <div className="login-modal-container flex-column align-stretch ">
        <p className="self-align-center" style={{ marginBottom: 20 }}>
          Acessar Conta
        </p>
        <form
          onSubmit={e => this.submitForm(e)}
          onKeyDown={e => this._keyDown(e)}
        >
          <Input
            inputProps={{
              placeholder: 'Informe seu email',
              value: login,
              onChange: this._onChangeLogin,
            }}
            iconProps={{
              fontFamily: 'MaterialCommunityIcons',
              name: 'email-outline',
              color: '#AAAAAA',
              size: 23,
            }}
            autoFocus={true}
          />
          <Input
            inputProps={{
              placeholder: 'Informe sua senha',
              value: password,
              onChange: this._onChangePassword,
              type: 'password',
            }}
            iconProps={{
              fontFamily: 'MaterialIcons',
              name: 'vpn-key',
              color: '#AAAAAA',
              size: 23,
            }}
          />
          <Button
            className="align-center justify-center"
            text="Entrar"
            onClick={e => this.submitForm(e)}
            style={{
              color: '#000000',
              boxShadow: '0 1px 10px rgba(0,0,0,0.2)',
              marginTop: 20,
              fontSize: 18,
            }}
          />
        </form>
        <ResetPasswordModal resetPassword={resetPassword} />
        <div
          className="flex-row justify-between align-center"
          style={{ margin: '20px 0' }}
        >
          <span className="login-modal-divider" />
          <p>ou</p>
          <span className="login-modal-divider" />
        </div>
        <GoogleLogin
          clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
          render={renderProps => (
            <Button
              image={googleLogo}
              onClick={renderProps.onClick}
              text="Continue com Google"
              style={{
                color: 'rgba(0, 0, 0, 0.54)',
                boxShadow: '0 1px 10px rgba(0,0,0,0.2)',
                marginBottom: 10,
                marginLeft: 0,
              }}
            />
          )}
          onFailure={this.responseProviderError}
          onSuccess={this.responseGoogle}
        />
        {/*         <FacebookLogin
          appId={process.env.REACT_APP_FACEBOOK_CLIENT_ID}
          fields="name,email,picture"
          callback={this.responseFacebook}
          onFailure={this.responseProviderError}
          render={renderProps => (
            <Button
              image={fbLogo}
              text="Continue com Facebook"
              onClick={renderProps.onClick}
              style={{
                boxShadow: '0 1px 10px rgba(0,0,0,0.2)',
                backgroundColor: '#4267B2',
                marginLeft: 0,
              }}
            />
          )}
        /> */}
      </div>
    );
  }
}

export default LoginModal;
